import type { ReactNode } from "react";

import { classNames } from "@alpacahq/ui/old";

export interface SavedInputProps {
  label: string;
  value: ReactNode;
}

export const SavedInput = ({ label, value }: SavedInputProps) => (
  <div className="flex items-baseline justify-between gap-4 py-1">
    <p className="m-0 p-0 font-semibold text-gray-800 text-sm">{label}</p>
    <div
      className={classNames(
        "text-right font-normal text-gray-700 text-sm",
        value == null && "text-gray-300",
      )}
    >
      {value ?? "-"}
    </div>
  </div>
);
